export const SET_TABLE_PAGE = "SET_TABLE_PAGE";
export const SET_BASIC_FILTERS = "SET_BASIC_FILTERS";
export const SET_EMAILS_ADVANCED_FILTERS = "SET_EMAILS_ADVANCED_FILTERS";
export const SET_EMAILS = "SET_MANAGER_EMAILS";
export const SET_TAG_TO_EMAILS = "SET_TAG_TO_EMAILS";
export const EDIT_EMAIL_TAGS = "EDIT_EMAIL_TAGS";
export const SET_ADVANCED_FILTERS_DATA = "SET_ADVANCED_FILTERS_DATA";
export const SET_USERS_DATA = "SET_USERS_DATA";
